<template>
  <div class="popup" v-if="loading">
    <head-title class="head-title">Email successfully changed!</head-title>
    <div class="popup__body">
      <div class="popup__message">
        You will be&nbsp;logged out now. Please sign in&nbsp;again with your new email.
      </div>
      <div class="popup__area">
        <spinner-el class="spinner"/>
        <div class="popup__notice">You will be automatically logged out</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { logoutTimeout } from 'src/utils/config';

export default {
  data: () => ({
    loading: true,
  }),
  methods: {
    ...mapActions('userData', ['logOut']),
    logoutUser() {
      this.logOut();
      this.$router.replace('/');
    },
  },
  computed: {
    ...mapState('userData', ['loginInfo']),
  },
  mounted() {
    const token = this.$route.query.token;
    const startChangeEmail = new Date();
    if (!token) {
      this.$router.replace('/email-change-confirm/token-invalid');
      return;
    }
    this.$apiService.confirmChangingEmail(token).then(() => {
      if (this.loginInfo) {
        const finishChangeEmail = new Date();
        const timeDiff = Math.abs(finishChangeEmail.getTime() - startChangeEmail.getTime());
        if (timeDiff < logoutTimeout) {
          setTimeout(() => {
            this.logoutUser();
          }, logoutTimeout - timeDiff);
        } else {
          this.logoutUser();
        }
      } else {
        this.$router.replace('/');
      }
    }).catch(() => {
      this.$router.replace('/email-change-confirm/token-invalid');
    });
  },
};
</script>

<style lang="scss" scoped>
  .popup {
    max-width: 420px;
    background: $white-color2;
    border-radius: 5px;
    margin: auto;
    &__body {
      padding: 28px 31px 26px 28px;
    }
    &__area {
      border-radius: 4px;
      @include customBorder(3px, 1px, 5px);
      padding-bottom: 60px;
    }
    &__notice {
      text-align: center;
      @include font(13px, $grey-color9, 500);
      line-height: 21px;
    }
    &__message {
      line-height: 21px;
      margin-bottom: 24px;
    }
    .head-title {
      @include font(24px, $black-color1, medium);
      border-bottom: 1px solid $white-color5;
      padding: 32px 28px;
    }
    .spinner {
      margin: 65px auto 25px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/EmailChangeConfirm.vue